<script>
import TwUploadField from '@/components/generic/uploads/tw-upload-field.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwNotification from '@/components/generic/notification/tw-notification.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { useFundraiserLayoutConfigurationStore } from '@/stores/fundraiserLayoutConfiguration.js'
import { useAuthStore } from '@/stores/auth.js'
import { useUsersStore } from '@/stores/users.js'
import ImageCropModal from '@/components/images/image-crop-modal.vue'
import TwGridDual from '@/components/generic/tw-grid-dual.vue'

export default {
  name: 'UserAvatarEditor',
  components: { TwGridDual, ImageCropModal, TwButton, TwValidationErrors, TwCard, TwUploadField },
  props: {
    labelKeyword: {
      type: String,
      default: 'Avatar'
    },
    user: {
      type: Object,
      required: false,
      default: function() {
        return useAuthStore().user
      }
    }
  },
  emits: ['updated', 'removed'],
  data() {
    return {
      Loading: false,
      LoadingRemovingImage: false,
      ValidationErrorMessage: null,
      UserAvatar: null,
    }
  },
  mounted() {
    this.UserAvatar = this.user.avatar
  },
  methods: {
    async uploadedImage(upload) {
      try {
        this.Loading = true
        const user = await useUsersStore().itemPatch( {
          id: this.user.id,
          avatar_id: upload.id
        })
        this.$notify(`${this.labelKeyword} set!`, 'success')
        this.Loading = false
        this.$emit('updated',upload)
        this.UserAvatar = upload
      } catch (e) {
        console.error(e)
        if(e.response) {
          this.ValidationErrorMessage = e.response.data
        }
        this.Loading = false
      }
    },
    async cropped(avatar) {
      this.Loading = true
      await useAuthStore().attempt_user()
      this.$forceUpdate()
      this.UserAvatar = avatar
      this.Loading = false
    },
    async removeImage() {
      try {
        if(confirm('Remove image?')) {
          this.LoadingRemovingImage = true
          const user = await useUsersStore().itemPatch( {
            id: this.user.id,
            avatar_id: null
          })
          this.LoadingRemovingImage = false
          this.$forceUpdate()
          this.$notify(`${this.labelKeyword} removed!`, 'success')
          this.$emit('removed')
          this.$emit('updated',null)
          this.UserAvatar = null
        }
      } catch (e) {
        console.error(e)
        if(e.response) {
          this.ValidationErrorMessage = e.response.data
        }
        this.LoadingRemovingImage = false
      }
    }
  }
}
</script>

<template>
  <div>
    <div>
      <div class="font-semibold font-forms">
        Profile or Headshot
      </div>
      <p class="text-sm text-gray-500 font-forms mt-1 mb-4">
        Useful to show in the list on the fundraiser page.
      </p>
      <tw-upload-field images-only block class="w-auto mb-4" @uploaded="uploadedImage">
        {{ UserAvatar? 'Replace':'Upload' }} {{ labelKeyword }}
      </tw-upload-field>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      <div v-if="UserAvatar" class="overflow-hidden rounded-lg bg-white shadow">
        <div :class="['p-3 flex justify-center', {'h-40': !readonly}]">
          <!-- Content goes here -->
          <a v-if="UserAvatar" :href="UserAvatar.url" target="_blank" class="text-blue-500 underline">
            <img :src="UserAvatar.url_small" class="inline-block min-w-32 h-32 w-32 rounded-full object-cover">
          </a>
        </div>
        <div v-if="UserAvatar" class="px-3 pb-3 flex gap-2">
          <tw-button size="sm" block variant="secondary" @click="$refs.imageCropModal.open()">
            <icon icon="scissors" class="h-3" /> Crop
          </tw-button>
          <tw-button v-if="UserAvatar" :loading="LoadingRemovingImage" variant="secondary" size="sm" block icon="trash" @click="removeImage" />
          <image-crop-modal ref="imageCropModal" :upload="UserAvatar" @cropped="cropped" />
        </div>
      </div>
    </div>
    <tw-validation-errors message-only :validation-result-error="ValidationErrorMessage" />
  </div>
</template>

<style scoped>

</style>
